import { Inject, Injectable, Injector } from '@angular/core';


import { FootPrintApiManager_log_notes_reportService } from './FootPrintApiManager.report.index';
import { FootPrintApiManager_transaction_reportService } from './FootPrintApiManager.report.index';

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public FootPrintApiManager: FootPrintApiManager_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
  private _log_notes_report: FootPrintApiManager_log_notes_reportService;
  public get log_notes_report(): FootPrintApiManager_log_notes_reportService {
    if(!this._log_notes_report) {
      this._log_notes_report = this.injector.get(FootPrintApiManager_log_notes_reportService);
    }
    return this._log_notes_report;
  }
  private _transaction_report: FootPrintApiManager_transaction_reportService;
  public get transaction_report(): FootPrintApiManager_transaction_reportService {
    if(!this._transaction_report) {
      this._transaction_report = this.injector.get(FootPrintApiManager_transaction_reportService);
    }
    return this._transaction_report;
  }
}

